import {
  useEligibilityCheck,
  useUpdateWithCheckResult,
} from "@mirage/eligibility/useEligibilityCheck";
import useDropboxAccount from "@mirage/service-auth/useDropboxAccount";
import { tagged } from "@mirage/service-logging";
import { useEffect, useState } from "react";

import type { dash_async } from "@dropbox/api-v2-client";

const logger = tagged("WebEligibilityCheck");

// Conditional hook as component.
export const WebEligibilityCheck: React.FC<{
  getEligibilityFromStore: () => Promise<
    dash_async.ShouldRedirectIneligibleUserResponse | undefined
  >;
  isDevboxBackend: boolean;
}> = ({ getEligibilityFromStore, isDevboxBackend }) => {
  const publicAccountId = useDropboxAccount()?.public_account_id;

  const [needCheck, setNeedCheck] = useState<boolean>();
  const updateWithCheckResult = useUpdateWithCheckResult(
    publicAccountId,
    isDevboxBackend,
  );

  useEffect(() => {
    if (needCheck !== undefined) {
      return;
    }

    let canceled = false;

    getEligibilityFromStore()
      .then((result) => {
        if (canceled) return;

        if (result) {
          setNeedCheck(false);
          updateWithCheckResult(result);
        } else {
          setNeedCheck(true);
        }

        return;
      })
      .catch((error) => {
        logger.error("Error fetching eligibility from store:", error);
        setNeedCheck(true);
      });

    return () => {
      canceled = true;
    };
  }, [getEligibilityFromStore, needCheck, updateWithCheckResult]);

  return needCheck && publicAccountId ? (
    <PerformCheck
      publicAccountId={publicAccountId}
      isDevboxBackend={isDevboxBackend}
    />
  ) : null;
};

// Conditional hook as component.
const PerformCheck: React.FC<{
  publicAccountId: string | undefined;
  isDevboxBackend: boolean;
}> = ({ publicAccountId, isDevboxBackend }) => {
  useEligibilityCheck(publicAccountId, isDevboxBackend);

  return null;
};
